import { Component, OnInit } from '@angular/core';
import { OperationService } from '../operation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalDataService } from '../../../../services/global-data.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-operation-list-item',
  templateUrl: './operation-list-item.component.html',
  styleUrls: ['./operation-list-item.component.css'],
  providers: [OperationService]
  
})
export class OperationListItemComponent implements OnInit {

private id: string;
public operation: any;
public title: string = "Список продуктов заявки";
messageDisplay:boolean = false;
operationItemModal: boolean = false;
loadingOperationItem: boolean = false;
operationItems: any = [];


  constructor(
    private operationService: OperationService,
    public global: GlobalDataService,
    private _location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router) {

      this.operation = {status : {id : null}};
      
      this.activatedRoute.params.subscribe(params=>{this.id=params['id']});

      this.loadOperationById(this.id);

      this.getItemListByOperationId(this.id);

     }


  ngOnInit() {

  }

  loadOperationById(operationId: string){

    this.operationService.getOperationById(this.id).subscribe(response=>{
      this.operation = response['data'];
      this.title = this.title + " - " + this.operation.invoice_number;

      if(this.operation.status.id == -1){
        this.title = this.title + "(Отменен)";

      }
    });
  }

  getItemListByOperationId(operationId: any) {
  //   console.log(operation);
  //   this.operation = operation;
  //   // this.saleItemId=this.sale.id;
  //   this.operationItems = [];
  //   this.operationItemModal = true;
     this.loadingOperationItem = true;
     this.operationService.getOperationItemsById(operationId).subscribe(response => {
       this.operationItems = response['data'];
       this.loadingOperationItem = false;
     })
   }

   OnMoveToSale() {
    this.router.navigate(['/dashboard/sale-update/', { contractor_id: this.operation.created_by.contractor_id, from_type: "operation", id: this.operation.id }])
  }

  onCancelOperation() {
    this.messageDisplay = true;
  }

 backClicked() {
    this._location.back();
}

OnAgreeCancel(){
  this.messageDisplay = false;

  this.operationService.cancelOperation({ id: this.operation.id }).subscribe(response => {
    this.operationItemModal=false;
    this.loadOperationById(this.id);
    });
}

OnDegreeCancel(){
  this.messageDisplay = false;
}
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/operations/operation-list-item/operation-list-item.component.ts